import React, { createContext, useContext, useState, useEffect } from 'react';

interface ProfileData {
  name: string;
  day: number;
  month: number;
  year: number;
}

interface ProfileContextType {
  profile: ProfileData;
  updateProfile: (data: ProfileData) => void;
}

const ProfileContext = createContext<ProfileContextType | undefined>(undefined);

const DEFAULT_PROFILE: ProfileData = {
  name: 'Harry Potter',
  day: 31,
  month: 7,
  year: 2001
};

export function ProfileProvider({ children }: { children: React.ReactNode }) {
  const [profile, setProfile] = useState<ProfileData>(() => {
    // Load from localStorage if available
    const saved = localStorage.getItem('numerology-profile');
    return saved ? JSON.parse(saved) : DEFAULT_PROFILE;
  });

  const updateProfile = (data: ProfileData) => {
    setProfile(data);
    localStorage.setItem('numerology-profile', JSON.stringify(data));
  };

  useEffect(() => {
    // Save to localStorage whenever profile changes
    localStorage.setItem('numerology-profile', JSON.stringify(profile));
  }, [profile]);

  return (
    <ProfileContext.Provider value={{ profile, updateProfile }}>
      {children}
    </ProfileContext.Provider>
  );
}

export function useProfile() {
  const context = useContext(ProfileContext);
  if (context === undefined) {
    throw new Error('useProfile must be used within a ProfileProvider');
  }
  return context;
}